import {
  CREATE_SALES_BILL,
  DELETE_SALES_BILL,
  GET_SALES_BILLS,
  GET_SALES_BILLS_PAGE,
  SALES_BILL_REQUEST,
  SALES_BILL_REQUEST_FAILURE,
  SALES_BILL_REQUEST_SUCCESS,
  GET_AVAILABLE_PURCHASE_BILLS,
  UPDATE_SALES_BILL,
  CANCEL_EWAY_BILL
} from "../types/sales-bill-types";

const initialState = {
  salesBills: [],
  salesBillsPage: [],
  availablePurchaseBills: [],
  page: 1,
  pageSize: 10,
  search: '',
  where: {},
  total: 0,
  loading: false,
  error: null,
};

const salesbillReducer = (state = initialState, action) => {
  switch (action.type) {
    case SALES_BILL_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_SALES_BILLS: {
      return {
        ...state,
        salesBills: [...action.payload],
        loading: false,
        error: null
      }
    }
    case GET_SALES_BILLS_PAGE: {
      const { data, total, page, pageSize, search, where } = action.payload || {};
      return {
        ...state,
        salesBillsPage: [...data],
        total,
        page,
        pageSize,
        search: search || '',
        where: where || {},
        loading: false,
        error: null
      }
    }
    case CREATE_SALES_BILL: {
      return {
        ...state,
        salesBills: [action.payload, ...state.salesBills],
        loading: false,
        error: null
      };
    }
    case UPDATE_SALES_BILL: {
      const salesBillsData = state.salesBills.slice(0);
      const uIndex = salesBillsData.findIndex((data) => data.id === action.payload.id);
      salesBillsData.splice(uIndex, 1, { ...action.payload.data });
      return {
        ...state,
        salesBills: [ ...salesBillsData ],
        loading: false,
        error: null
      };
    }
    case DELETE_SALES_BILL: {
      const salesBills = state.salesBills?.slice(0);
      const index = salesBills.findIndex((data) => data.id === action.id);
      if (index > -1) {
        salesBills.splice(index, 1);
      }
      return {
        ...state,
        salesBills: [...salesBills],
        loading: false,
        error: null
      }
    }
    case GET_AVAILABLE_PURCHASE_BILLS: {
      return {
        ...state,
        availablePurchaseBills: [...action.payload],
        loading: false,
        error: null
      }
    }
    case SALES_BILL_REQUEST_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null
      }
    }
    case SALES_BILL_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    case CANCEL_EWAY_BILL: {
      return {
        ...state,
        loading: false,
        error: null
      }
    }
    default:
      return state;
  }
};

export default salesbillReducer;
